export const getPageSize = (expertPage: boolean = false): number => {
  const otherHeight = (window.innerWidth < 1440 || expertPage) ? 200 : 220;
  const diff = expertPage ? 105 : 80;
  if (expertPage && window.innerWidth < 1210) {
    return Math.round((window.innerHeight - otherHeight) / diff);
  }
  return Math.round((window.innerHeight - otherHeight) / diff); // 80 - height of column, 200 - another block height & header of table
}
